import ReactGA from "react-ga4";
import React from "react";

const UseGAEventsTracker = (category = "Category") => {
    const trackEvent = (action = "action", label = "label") => {
        // console.log("called", action, label, category);
        console.log(`GA: Category-->${category} action-->${action} label-->${label}`);

        ReactGA.event({
            category,
            action,
            label,
        });
    };
    return trackEvent;

    // return (
    //   <div>UseGAEventsTracker</div>
    // )
};

export default UseGAEventsTracker;
